// Blue theme
const blue = {
  id: 'blue',
  name: 'Sininen',
  price: 25,
  main: '#1976d2',
  light: '#42a5f5',
  dark: '#1565c0',
  bg: '#e3f2fd',
  darkBg: '#1a2233',
  isSuper: false,
  surfaces: {
    // Light mode
    lightBg: '#c8e4fa',
    lightPaper: '#e3f2fd',
    lightContainer: '#e3f2fd',
    lightOnSurface: '#1a1a2e',
    lightOnSurfaceVariant: '#3d5570',
    lightOutline: '#6088b0',
    // Dark mode
    containerLowest: '#121d2e',
    containerLow: '#060d18',
    container: '#121d2e',
    containerHigh: '#263448',
    containerHighest: '#2e3e54',
    bright: '#384a62',
    onSurface: '#d8eaff',
    onSurfaceVariant: '#9ab8d8',
    outline: '#6088b0',
    outlineVariant: '#354d6a',
    // Button colors — primary
    primaryContainer: '#42a5f5',
    onPrimaryContainer: '#002c4a',
    // Button colors — secondary (outlined)
    secondaryContainer: '#1a3550',
    onSecondaryContainer: '#90c8f0',
    // Button colors — secondary (filled)
    secondary: '#90caf9',
    onSecondary: '#0d3c61',
    secondaryLight: '#0d47a1',
    onSecondaryLight: '#ffffff',
    // Button colors — inverse
    inverseSurface: '#e3f2fd',
    onInverseSurface: '#1a2233',
    inverseSurfaceLight: '#1a2233',
    onInverseSurfaceLight: '#d8eaff',
    // Button colors — label/text
    labelColor: '#42a5f5',
    labelColorLight: '#1565c0',
    // Status colors
    success: '#4caf50',
    successLight: '#81c784',
    successDark: '#2e7d32',
    warning: '#ed6c02',
    warningLight: '#ff9800',
    warningDark: '#e65100',
    error: '#ef5350',
    errorLight: '#ff7961',
    errorDark: '#c62828',
  },
};

export default blue;
